var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-manager-container"
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-manager-container-title",
          class: {
            "cw-manager-container-clickable-title": _vm.inserter
          },
          on: {
            click: _vm.clickItem
          }
        },
        [
          _vm.inserter
            ? _c(
                "span",
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "arr_2left",
                      role: "sort"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(
            "\n        " +
              _vm._s(_vm.container.attributes.title) +
              " (" +
              _vm._s(_vm.container.attributes.width) +
              ")\n        "
          ),
          _vm.sortContainers
            ? _c(
                "div",
                {
                  staticClass: "cw-manager-container-buttons"
                },
                [
                  _c(
                    "button",
                    {
                      attrs: {
                        disabled: !_vm.canMoveUp,
                        title: _vm.$gettext("Element nach oben verschieben")
                      },
                      on: {
                        click: _vm.moveUp
                      }
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "arr_2up",
                          role: "sort"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: {
                        disabled: !_vm.canMoveDown,
                        title: _vm.$gettext("Element nach unten verschieben")
                      },
                      on: {
                        click: _vm.moveDown
                      }
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "arr_2down",
                          role: "sort"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "courseware-collapsible-box",
        {
          staticClass: "cw-manager-container-blocks",
          attrs: {
            open: false,
            title: _vm.$gettext("Blöcke")
          }
        },
        [
          _vm.canSortChildren
            ? _c("div", [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.sortBlocksActive && _vm.isCurrent,
                        expression: "!sortBlocksActive && isCurrent"
                      }
                    ],
                    staticClass: "button sort",
                    on: {
                      click: _vm.sortBlocks
                    }
                  },
                  [_c("translate", [_vm._v("Blöcke sortieren")])],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.sortBlocksActive && _vm.isCurrent,
                        expression: "sortBlocksActive && isCurrent"
                      }
                    ],
                    staticClass: "button accept",
                    on: {
                      click: _vm.storeBlocksSort
                    }
                  },
                  [_c("translate", [_vm._v("Sortieren beenden")])],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.sortBlocksActive && _vm.isCurrent,
                        expression: "sortBlocksActive && isCurrent"
                      }
                    ],
                    staticClass: "button cancel",
                    on: {
                      click: _vm.resetBlocksSort
                    }
                  },
                  [_c("translate", [_vm._v("Sortieren abbrechen")])],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.hasChildren
            ? _c(
                "p",
                [
                  _c("translate", [
                    _vm._v("Dieser Abschnitt enthält keine Blöcke.")
                  ])
                ],
                1
              )
            : _vm.sectionsWithBlocksCurrentState.length === 1
            ? _c(
                "div",
                [
                  _c(
                    "transition-group",
                    {
                      attrs: {
                        name: "cw-sort-ease",
                        tag: "div"
                      }
                    },
                    _vm._l(
                      _vm.sectionsWithBlocksCurrentState[0].blocks,
                      function(block, blockIndex) {
                        return _c("courseware-manager-block", {
                          key: block.id,
                          attrs: {
                            block: block,
                            inserter: _vm.blockInserter,
                            sortBlocks: _vm.sortBlocksActive,
                            canMoveUp: blockIndex !== 0,
                            canMoveDown:
                              blockIndex + 1 !==
                              _vm.sectionsWithBlocksCurrentState[0].blocks
                                .length,
                            elementType: _vm.elementType,
                            sectionId: 0
                          },
                          on: {
                            insertBlock: _vm.insertBlock,
                            moveUp: _vm.moveBlockUp,
                            moveDown: _vm.moveBlockDown
                          }
                        })
                      }
                    ),
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                _vm._l(_vm.sectionsWithBlocksCurrentState, function(
                  section,
                  index
                ) {
                  return _c(
                    "courseware-collapsible-box",
                    {
                      key: section.id,
                      staticClass: "cw-manager-container-blocks",
                      attrs: {
                        open: true,
                        title: section.name
                      }
                    },
                    [
                      _c(
                        "transition-group",
                        {
                          attrs: {
                            name: "cw-sort-ease",
                            tag: "div"
                          }
                        },
                        _vm._l(
                          _vm.sectionsWithBlocksCurrentState[index].blocks,
                          function(block, blockIndex) {
                            return _c("courseware-manager-block", {
                              key: block.id,
                              attrs: {
                                block: block,
                                inserter: _vm.blockInserter,
                                sortBlocks: _vm.sortBlocksActive,
                                canMoveUp: blockIndex !== 0 || index !== 0,
                                canMoveDown:
                                  index + 1 !==
                                    _vm.sectionsWithBlocksCurrentState.length ||
                                  blockIndex + 1 !==
                                    _vm.sectionsWithBlocksCurrentState[index]
                                      .blocks.length,
                                elementType: _vm.elementType,
                                sectionId: index
                              },
                              on: {
                                insertBlock: _vm.insertBlock,
                                moveUp: _vm.moveBlockUp,
                                moveDown: _vm.moveBlockDown
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              ),
          _vm._v(" "),
          _vm.isCurrent && !_vm.sortContainers && !_vm.sortBlocksActive
            ? _c("courseware-manager-filing", {
                attrs: {
                  parentId: _vm.container.id,
                  parentItem: _vm.container,
                  itemType: "block"
                },
                on: {
                  deactivated: _vm.reloadContainer
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }